// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper---SndG3","heading":"heading---CrtZo","list":"list---u4tV0"};